//Iconos
// require("./vendor/js/iconify")
// require("bootstrap/dist/js/bootstrap")


window.$ = window.jQuery = require('jquery');
require("owl.carousel")
